import script from "./OBOCert.vue?vue&type=script&setup=true&lang=js"
export * from "./OBOCert.vue?vue&type=script&setup=true&lang=js"

import "./OBOCert.vue?vue&type=style&index=0&id=f75b3554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f75b3554"]])

export default __exports__